var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"pt-3 pb-3"},[_c('b-col',{staticClass:"mr-auto",attrs:{"cols":"12","md":"auto"}},[_c('h3',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.title))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }